module.exports = __webpack_public_path__ + "static/media/imix-tab2.a0d0c1bc.png";